module.exports = __webpack_public_path__ + "img/ld.406464ed.svg";